export enum PeriodoBuscaEnum {
    Hoje = 1,
    DaSemana = 2,
    DoMes = 3,
    Ultimos30Dias = 4,
    DoIntervalo = 5,
}